import React, { useEffect, useState } from 'react'
import { get24HoursDateTimeForFB } from '../common/helper'
// import FeedbackButton from './FeedbackButton'
//import FeedbackContent from './feedbackContent';
import FeedbackContentNew from './FeedbackContentNew';

const Tickets = ({ source, destination, departure, arrival, pnr, serviceClass, isGuest=false, CategoriesData=false, RatingData = false, readOnly=false, submitFeedback, getFdbkByPnr }) => {
    const [activeBtn, setActiveBtn] = useState(false)
    const handleFeedbackBtn = () => {
        setActiveBtn(prevState => !prevState)
    }

    useEffect(()=>{
        if(isGuest){
            setActiveBtn(true);
        }
    },[isGuest])

    return (
        <>
            <div className={`ticket ${activeBtn?'active':''} ${readOnly?'readOnly':''}`}>
                <div className="ticket-details">
                    <div className="time-details">
                        <div className='time'>
                            <span className='departure-time'>{get24HoursDateTimeForFB(departure)}</span>
                            <span className='source-city'>{source}</span>
                        </div>
                        <div className='status'>
                            <span style={{ paddingTop: '1px' }}><svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.800049 11.5V0.5L10.8 6L0.800049 11.5Z" fill="#4FBA99" />
                            </svg>
                            </span>
                            <span style={{ border: '1px solid #4FBA99', height: '0px', width: '10px' }}></span>

                            <span style={{ padding: '0px 5px' }}>Completed</span>
                            <span style={{ border: '1px solid #E72A01', height: '0px', width: '10px' }}></span>

                            <span><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.800049 9.5V0.5H9.80005V9.5H0.800049Z" fill="#E72A01" />
                            </svg>
                            </span>
                        </div>
                        <div className='time'>
                            <span className='departure-time'>{get24HoursDateTimeForFB(arrival)}</span>
                            <span className='source-city'>{destination}</span>
                        </div>
                        <div className="additional-info">
                            <span>PNR No.: {pnr}</span>
                            <span className="service-class">{serviceClass}</span>
                        </div>
                    </div>
                </div>
                <button className={activeBtn ? "close-feedback-btn" : "give-feedback-btn"} onClick={() => {
                    // getFdbkByPnr(); 
                     handleFeedbackBtn()
                    } }>{activeBtn ? "CLOSE FEEDBACK" : "GIVE FEEDBACK"}</button>
                {/* readOnly && <div className='cmntMsg'>
                    <span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 14H18V12H6V14ZM6 11H18V9H6V11ZM6 8H18V6H6V8ZM4 18C3.45 18 2.97917 17.8042 2.5875 17.4125C2.19583 17.0208 2 16.55 2 16V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V22L18 18H4Z" fill="#01AEF0"/>
                        </svg>
                    </span>
                    <span>
                        We sincerely apologise for your experience. We assure you that we shall take corrective actions. We wish to see you again and serve you better.
                    </span>
                    </div> */}
            </div>
            {/* {activeBtn && <FeedbackButton activeBtn={activeBtn} />} */}
            {/*activeBtn && <FeedbackContent activeBtn={activeBtn} CategoriesData={CategoriesData} readOnly={readOnly} RatingData={RatingData} submitFeedback = {submitFeedback}/>*/}
            {activeBtn && <FeedbackContentNew CategoriesData={CategoriesData} readOnly={readOnly} RatingData={RatingData} submitFeedback = {submitFeedback}/>}
        </>
    )
}

export default Tickets
